var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Navbar'),(!_vm.hasData)?_c('NoData'):[_c('NavDrawings'),_c('Drawing',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected == 1),expression:"selected == 1"}]}),_c('DrawingCuadratic',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected == 2),expression:"selected == 2"}]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }